import { ImChatMessage } from "./chat.entity"

export const normalizeChatMessage = (message: ImChatMessage) => {

  return{    
    ...message,
    t: message.t?.toMillis() ?? new Date().getTime(),
  }
}
